import React, {useState, useEffect} from "react";
import {Chart} from "primereact/chart";

export default function ChartDoughnut(props) {
	const [chartData, setChartData] = useState({});
	const [chartOptions, setChartOptions] = useState({});

	useEffect(() => {
		const documentStyle = getComputedStyle(document.documentElement);

		const data = {
			labels: ["A", "B", "C"],
			datasets: [
				{
					data: [540, 325, 702],
					backgroundColor: [
						documentStyle.getPropertyValue("--blue-500"),
						documentStyle.getPropertyValue("--yellow-500"),
						documentStyle.getPropertyValue("--green-500"),
					],
					hoverBackgroundColor: [
						documentStyle.getPropertyValue("--blue-400"),
						documentStyle.getPropertyValue("--yellow-400"),
						documentStyle.getPropertyValue("--green-400"),
					],
					borderWidth: 2,
					cutout: "60%", // Makes it a doughnut chart
				},
			],
		};

		const options = {
			plugins: {
				legend: {
					position: "top",
					labels: {
						usePointStyle: true,
						font: {
							size: 14,
							weight: "bold",
						},
					},
				},
			},
		};

		setChartData(data);
		setChartOptions(options);
	}, []);

	return (
		<div className="d-flex justify-content-center mx-auto">
			<Chart
				type="doughnut"
				data={chartData}
				options={chartOptions}
				className="w-100 p-3"
				// style={{height: "250px"}}
			/>
		</div>
	);
}
